"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const zustandStore_1 = require("../../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../../atoms/button/simpleButton"));
const SaveChangesButton = ({ onSaveChanges }) => {
    const { isSaveBtnDisabled, isTeamNameError, isTeamRequestLimitError } = (0, zustandStore_1.useZustand)(state => ({
        isTeamNameError: state.team.isTeamNameError,
        isTeamRequestLimitError: state.team.isTeamRequestLimitError,
        isSaveBtnDisabled: state.modal.team.isSaveBtnDisabled,
    }));
    return ((0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "save-changes-btn", label: strings_1.teamSettingsOverviewStrings.HEADER_BUTTON_NAME, onClick: onSaveChanges, disabled: isSaveBtnDisabled || isTeamNameError || isTeamRequestLimitError, color: uiConstants_1.UI_BUTTON_PRIMARY }));
};
exports.default = SaveChangesButton;
